import type { AnalyticsMetric, AnalyticsSeriesPoint } from '@sia/analytics-contracts';
import { SparklineChart } from '@/components/charts';

export function MetricCard({ metric, featured = false, label, note, invertTrend = false, neutralTrend = false, trend, trendTitle, trendUnit = 'count', showFailureDetails = false }: { metric: AnalyticsMetric; featured?: boolean; label?: string; note?: string; invertTrend?: boolean; neutralTrend?: boolean; trend?: AnalyticsSeriesPoint[]; trendTitle?: string; trendUnit?: 'count' | 'percent'; showFailureDetails?: boolean }) {
  const unavailable = metric.state !== 'ready';
  const inlineContext = metric.state === 'ready' && (metric.id === 'total-live-listings' || metric.id === 'total-alerts-sent') ? metric.note : null;
  const hasNote = Boolean((note ?? metric.note) && !inlineContext);
  const deltaPercent = metric.deltaPercent;
  const hasDelta = deltaPercent !== undefined && deltaPercent !== null;
  return (
    <article className={`metric-card${featured ? ' metric-card--featured' : ''}`}>
      <p className="metric-card__label">{label ?? metric.label}</p>
      <p className={`metric-card__value${unavailable ? ' metric-card__value--empty' : ''}${!hasNote && !hasDelta ? ' metric-card__value--spaced' : ''}`}>
        {metric.state === 'insufficient_maturity'
          ? '—'
          : metric.state === 'not_applicable'
            ? 'Not applicable'
            : unavailable ? 'Awaiting data' : <>{metric.formattedValue}{inlineContext ? <span className="metric-card__value-context">{inlineContext}</span> : null}</>}
      </p>
      {hasDelta ? (
        <p className={`metric-card__delta ${neutralTrend || Math.round(deltaPercent * 10) === 0 ? 'is-neutral' : (invertTrend ? deltaPercent <= 0 : deltaPercent >= 0) ? 'is-positive' : 'is-negative'}`}>
          {deltaPercent >= 0 ? '+' : ''}{deltaPercent.toFixed(1)}% vs previous period
        </p>
      ) : null}
      {hasNote ? <p className="metric-card__note">{note ?? metric.note}</p> : null}
      {trend?.length ? <SparklineChart title={trendTitle ?? metric.label} data={trend} formatAsPercent={trendUnit === 'percent'} showFailureDetails={showFailureDetails} /> : null}
    </article>
  );
}
